module.exports = __webpack_public_path__ + "static/media/sergio_spanish_castilian.3a926fa8.mp3";